import {
	UPDATE_ALLERGEN,
	SET_ALLERGEN,
	RESET_ALLERGEN
} from './allergens.actions';

const defaultState = {
	ui: {},
	data: {
		defaultAllergen: {}
	}
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
	case SET_ALLERGEN: {
		return {
			...state,
			data: {
				...state.data,
				defaultAllergen: payload
			}
		};
	}

	case UPDATE_ALLERGEN: {
		return {
			...state,
			data: {
				...state.data,
				defaultAllergen: {
					...state.data.defaultAllergen,
					name: payload.name,
					allergen_category: payload.allergen_category
				}
			}
		};
	}

	case RESET_ALLERGEN: {
		return {
			...state,
			data: {
				...state.data,
				defaultAllergen: {}
			}
		};
	}

	default:
		return state;
	}
}

export default reducer;
